export const fontSizes = {
  xs: '0.8rem',
  sm: '1.25rem',
  md: '1.563rem',
  lg: '1.953rem',
  xl: '2.441rem',
  x2l: '3.052rem',
}
